import {
    SWITCH_ROLES_REQUEST,
    SWITCH_ROLES_SUCCESS,
    SWITCH_ROLES_ERROR
  } from "./SwitchRolesTypes";
  
  const initialState = {
    loading: false,
    error: "",
    switchRoles: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case SWITCH_ROLES_REQUEST:
        return {
          ...state,
          loading: true
        };
      case SWITCH_ROLES_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          switchRoles: action.payload,
          error: ""
        };
      case SWITCH_ROLES_ERROR:
        return {
          ...state,
          loading: false,
          switchRoles: [],
          error: action.payload
        };
      default:
        return state;
    }
  };
  